export default [
  {
    url: { name: 'expedientes-dashboard', params: { view: 'files' } },
    name: 'Dashboard',
    icon: 'ListIcon',
    permiso: 'ED148',
    i18n: 'uploads'
  },
  {
    url: { name: 'expedientes-dashboard', params: { view: 'my-files' } },
    name: 'Mi Dashboard',
    icon: 'ListIcon',
    permiso: 'ED148',
    i18n: 'uploads'
  },
  {
    header: 'Docs. Escritorio Digital',
    icon: 'PackageIcon',
    i18n: 'Documentos',
    items: [
      {
        url: null,
        name: 'Registro de Documentos',
        slug: 'files',
        icon: 'FolderIcon',
        permiso: 'ED049',
        submenu: [
          {
            url: { name: 'files-wizard', params: { wizard: 'numOf' } },
            name: 'Numeración Of. Partes',
            icon: 'files',
            permiso: 'ED043',
            i18n: 'uploads'
          },
          {
            url: { name: 'files-wizard', params: { wizard: 'numInt' } },
            name: 'Numeración interna',
            icon: 'files',
            permiso: 'ED044',
            i18n: 'uploads'
          },
          {
            url: { name: 'files-wizard', params: { wizard: 'interno' } },
            name: 'Doc. sin numeración',
            icon: 'files',
            permiso: 'ED045',
            i18n: 'uploads'
          },
          {
            url: { name: 'files-wizard', params: { wizard: 'externo' } },
            name: 'Ingreso Doc. Externo',
            icon: 'files',
            permiso: 'ED012',
            i18n: 'uploads'
          },
          {
            url: { name: 'conventionInputForm' },
            name: 'Ingreso documentos',
            icon: 'InboxIcon',
            permiso: 'ED126'
          },
          {
            url: { name: 'files-wizard', params: { wizard: 'sharedExternal' } },
            name: 'SISS externo',
            icon: 'files',
            permiso: 'ED145',
            i18n: 'uploads'
          }
        ]
      },
      {
        url: null,
        name: 'Bandejas',
        slug: 'InboxIcon',
        icon: 'FileIcon',
        permiso: 'ED116',
        submenu: [
          {
            url: { name: 'files', params: { view: 'pendientes' } },
            name: 'Mis Pendientes',
            icon: 'InboxIcon',
            permiso: 'ED009',
            i18n: 'expedientes'
          },
          {
            url: { name: 'files', params: { view: 'pendientes-unidad' } },
            name: 'Mis Pendientes unidad',
            icon: 'InboxIcon',
            permiso: 'ED233',
            i18n: 'expedientes'
          },
          {
            url: { name: 'files', params: { view: 'borradores' } },
            name: 'Mis Borradores',
            icon: 'PackageIcon',
            permiso: 'ED008',
            i18n: 'borradores'
          },
          {
            url: { name: 'custom-documents-drafts' },
            name: 'Borradores personalizados',
            icon: 'PackageIcon',
            permiso: 'ED277',
            i18n: 'borradoresPersonalizados'
          },
          {
            url: { name: 'files', params: { view: 'general' } },
            name: 'General',
            icon: 'HardDriveIcon',
            permiso: 'ED011',
            i18n: 'expedientes'
          },
          {
            url: { name: 'files', params: { view: 'finalizados' } },
            name: 'Mis docs. Finalizados',
            icon: 'ArchiveIcon',
            permiso: 'ED038',
            i18n: 'expedientes'
          },
          {
            url: { name: 'files', params: { view: 'tramitados' } },
            name: 'Mis docs. Tramitados',
            icon: 'AwardIcon',
            permiso: 'ED010',
            i18n: 'expedientes'
          },
          {
            url: { name: 'files', params: { view: 'ingresados' } },
            name: 'Docs. Ingresados',
            icon: 'AwardIcon',
            permiso: 'ED127',
            i18n: 'expedientes'
          },
          {
            url: { name: 'files', params: { view: 'completitudDatos' } },
            name: 'Completitud de datos',
            icon: 'AwardIcon',
            permiso: 'ED128',
            i18n: 'expedientes'
          },
          {
            url: { name: 'opent-text' },
            name: 'Librería',
            icon: 'ArchiveIcon',
            permiso: 'ED133',
            i18n: 'expedientes'
          }
        ]
      },
      {
        url: null,
        name: 'DocDigital',
        slug: 'settings',
        icon: 'FolderIcon',
        permiso: 'ED115',
        submenu: [
          {
            url: { name: 'dd-files', params: { view: 'recibidos' } },
            name: 'Recibidos',
            icon: 'HardDriveIcon',
            permiso: 'ED100',
            i18n: 'dd-files'
          },
          {
            url: { name: 'dd-files', params: { view: 'salientes' } },
            name: 'Salientes',
            icon: 'HardDriveIcon',
            permiso: 'ED100',
            i18n: 'dd-files'
          },
          {
            url: { name: 'files', params: { view: 'presalida' } },
            name: 'Pre Envío',
            icon: 'HardDriveIcon',
            permiso: 'ED100',
            i18n: 'expedientes'
          },
          {
            url: { name: 'dd-entidades' },
            name: 'Entidades',
            icon: 'BuildingIcon',
            permiso: 'FEB99'
          },
          {
            url: { name: 'dd-tipos-documentos' },
            name: 'Tipos documentos',
            icon: 'BuildingIcon',
            permiso: 'FEB99'
          }
        ]
      },
      {
        url: null,
        name: 'Aprobaciones',
        slug: 'InboxIcon',
        icon: 'FileIcon',
        permiso: 'ED056',
        submenu: [
          {
            url: { name: 'approval-dashboard' },
            name: 'Dashboard aprobaciones',
            icon: 'GlobeIcon',
            permiso: 'ED076'
          },
          {
            url: { name: 'new-flow', params: { wizard: 'newFlow' } },
            name: 'Iniciar flujo',
            icon: 'UploadIcon',
            permiso: 'ED109'
          },
          {
            url: { name: 'approval-trays', params: { view: 'entrada' } },
            name: 'Bandeja entrada',
            icon: 'InboxIcon',
            permiso: 'ED055'
          },
          {
            url: { name: 'approval-trays', params: { view: 'salida' } },
            name: 'Bandeja salida',
            icon: 'ArchiveIcon',
            permiso: 'ED057'
          },
          {
            url: { name: 'approval-trays', params: { view: 'observador' } },
            name: 'Bandeja observador',
            icon: 'InboxIcon',
            permiso: 'ED238'
          },
          {
            url: { name: 'approval-trays', params: { view: 'enviados' } },
            name: 'Bandeja Mis Enviados',
            icon: 'LayersIcon',
            permiso: 'ED102'
          },
          {
            url: { name: 'approval-trays', params: { view: 'general' } },
            name: 'Bandeja General',
            icon: 'InboxIcon',
            permiso: 'ED131'
          },
          {
            url: { name: 'approval-trays', params: { view: 'pre-oficina' } },
            name: 'Asignación docs.',
            icon: 'InboxIcon',
            permiso: 'ED141'
          },
          {
            url: { name: 'approval-trays', params: { view: 'tramitar-numerar' } },
            name: 'Tramitar y Numerar',
            icon: 'InboxIcon',
            permiso: 'ED118'
          },
          {
            url: { name: 'approval-massive', params: { view: 'masiva' } },
            name: 'Bandeja Procesos Masivos',
            icon: 'InboxIcon',
            permiso: 'ED149'
          },
          {
            url: { name: 'approval-trays', params: { view: 'entrada-jefatura' } },
            name: 'Bandeja observ. Jefatura',
            icon: 'InboxIcon',
            permiso: 'ED143'
          },
          {
            url: { name: 'new-flow', params: { wizard: 'newFlowEp' } },
            name: 'Iniciar flujo EP',
            icon: 'UploadIcon',
            permiso: 'ED132'
          }
        ]
      },
      {
        url: null,
        name: 'Config. aprobaciones',
        slug: 'templates',
        icon: 'GridIcon',
        permiso: 'ED105',
        submenu: [
          {
            url: { name: 'approval-substitutions' },
            name: 'Reemplazos',
            slug: 'settings',
            icon: 'UsersIcon',
            permiso: 'ED104'
          },
          {
            url: { name: 'approval-templates', params: { view: 'create' } },
            name: 'Crear plantilla',
            slug: 'settings',
            icon: 'UsersIcon',
            permiso: 'ED121'
          },
          {
            url: { name: 'approval-templates' },
            name: 'Listar plantillas',
            slug: 'settings',
            icon: 'UsersIcon',
            permiso: 'ED122'
          },
          {
            url: { name: 'maintainer-attachment-types' },
            name: 'Tipos de adjuntos',
            slug: 'settings',
            icon: 'UsersIcon',
            permiso: 'ED132' // TODO: set permission
          }
        ]
      }
    ]
  }];
